import { useEffect, useState } from "react"
import "./sendMessageNoPerformerNotify.css"
import "./sendMessageNoPerformerNotifyDark.css"
import { useSelector } from "react-redux"
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'

export default function SendMessageNoPerformerNotify({ setShow, show, selectPerformerFunc }) {
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
  let onlineUSers = useSelector(onlineUSers => onlineUSers);
  const getDarkModoe = useSelector(darkModes => darkModes);
  let adminIfno = useSelector(adminIfno => adminIfno)
  const handleShow = (event) => {
    setShow(!show)
    console.log(!event.target.matches('.dropbtn'));
  }



  useEffect(() => {
    const handlecCloseWind = (event) => {

      if (!event.target.matches('.material-symbols-outlined')) {
        setShow(false)
      }
    }

    window.addEventListener('click', handlecCloseWind);

    // Detach the event listener when the component unmounts
    return () => {
      window.removeEventListener('click', handlecCloseWind);
    };

  }, [])

  function reduceText(text,type) {
      if (type == "name") {
          if (text.length > 5) {
            console.log(text.length, "asdasd");
            return text.slice(0, 5) + '...';
        }
      }else{
        if (text.length > 18) {
          console.log(text.length, "asdasd");
          return text.slice(0, 18) + '...';
      }
      }
   
    return text;
}

  return (
    <>
      <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "dropdownNotifySendMsgLigthDark" : "dropdownNotifySendMsgLigth"}>
        <button className="dropbtnNotify" onClick={(e) => handleShow(e)}>
          <span class="material-symbols-outlined">alternate_email</span>


        </button>
        {
          show ?
            <div id="myDropdown" className="dropdown-contentNotify">
{/* admin */}
                
              <div onClick={() => selectPerformerFunc(adminIfno.rootReducer.users.adminInfo)}>
                    {
                       adminIfno.rootReducer.users.adminInfo.online ?
                        <Avatar size={"sm"} src={adminIfno.rootReducer.users.adminInfo.img?adminIfno.rootReducer.users.adminInfo.img:"https://bit.ly/broken-link"}>
                        <AvatarBadge boxSize='0.9em' bg='green.500' />
                      </Avatar>
                        :
                        <Avatar size={"sm"} src={adminIfno.rootReducer.users.adminInfo.img?adminIfno.rootReducer.users.adminInfo.img:"https://bit.ly/broken-link"}>
                        
                      </Avatar>
                    }
                
                <p>{reduceText(adminIfno.rootReducer.users.adminInfo.name,"name")}</p>
                <p>{reduceText(adminIfno.rootReducer.users.adminInfo.email)}</p>
              </div>
              {/* preformer */}
              {
                gerChekcedCompany.rootReducer.users.data?.map((item, index) => {
                  return onlineUSers.getOnlineUserViaRouterReducer.users.data?.includes(item.workerID) ?
                    <div onClick={() => selectPerformerFunc(item)} key={index}>

                      <Avatar name={item.name} size={"sm"} src={item.img ? item.img : "https://bit.ly/broken-link"}>
                        <AvatarBadge boxSize='0.9em' bg='green.500' />
                      </Avatar>
                      
                      <p>{item.name ? reduceText(item.name,"name") : reduceText(item.tel)}</p>
                      <p>{reduceText(item.email)}</p>
                    </div>
                    :
                    <div onClick={() => selectPerformerFunc(item)} key={index}>

                      <Avatar size={"sm"} src={item.img ? item.img : "https://bit.ly/broken-link"}>

                      </Avatar>
                      <p>{item.name ? reduceText(item.name,"name") : reduceText(item.tel)}</p>
                      <p>{reduceText(item.email)}</p>
                    </div>

                })
              }


            </div>
            :
            ""
        }

      </div>
    </>
  );
}